const Tooltip = ({ value }) => {
  return value
}

export default Tooltip
